import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../assets/stylesheets/_settings.global.scss';

const vGap = 15;

const Container = styled.div`
  color: white;
  width: 100%;
  padding: ${props => (props.theme.isMobile ? '30px 20px' : '30px 40px')};
  border-radius: 10px;
  position: relative;
  background: ${props => props.theme.bodyColor};
  background: ${props => (props.theme.isMobile ? props.theme.linearGradientDarkThemeSquare : props.theme.linearGradientDarkThemeRect)};
  box-shadow: 0 2px 3px ${props => props.theme.darkShadowColor};
`;

const Header = styled.h4`
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 24px;
  line-height: 31px;
  text-transform: none;
  margin: 0;
  ${props => (!props.theme.isMobile && `
    margin-right: 75px;
  `)};
`;

const Separator = styled.hr`
  height: 1px;
  width: 88px;
  background-color: ${props => props.theme.primaryColor};
  border: 0px;
  margin-top: ${vGap}px;
  margin-bottom: ${vGap}px;
  text-align: left;
  margin-left: 0;
`;

const Desc = styled.p`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 15px;
  line-height: 18px;
`;

const Footer = styled.div`
  margin-top: ${vGap}px;
  display: flex;
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};
  align-items: center;
`;

const Button = styled.button`
  width: ${props => (props.theme.isMobile ? '100%' : '234px')};
  color: white;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border: none;
  border-radius: 4px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 16px;
  padding: 10px 20px;
  text-transform: uppercase;

  &:hover {
    background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  }

`;

const Aside = styled.span`
  ${props => (props.theme.isMobile ? `
    margin-top: 30px;
  ` : `
    margin-left: 20px;
  `)};
  font-size: 12px;
`;

const signUp = evt => {
  evt && evt.preventDefault();
  window.location = '/sign_up';
};

const signIn = evt => {
  evt && evt.preventDefault();
  window.location = '/sign_in';
};

export default function PromptToJoin() {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  return (
    <ThemeProvider theme={{ ...theme, isMobile }}>
      <Container>
        <Header>
          {'Welcome to Livewire, Australia’s most trusted'
            + ' source of investment insights and analysis.'}
        </Header>
        <Separator />
        <Desc>
          {'To continue reading this wire and get unlimited access to Livewire'
            + ', join for free now and become a more informed and confident'
            + ' investor.'}
        </Desc>
        <Footer>
          <Button type="button" onClick={signUp}>join free now</Button>
          <Aside>
            {'Already have an account? '}
            <a href="#" onClick={signIn}>Sign in here</a>
          </Aside>
        </Footer>
      </Container>
    </ThemeProvider>
  );
}
